










































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { RepurchaseConfigDto } from '../model/index'

@Component
export default class RepurchaseSetting extends Vue {
  @Prop({
    type: Object,
    default: () => {
      return {
        period: 0,
        pepercents: [{ direct: 0, indirect: 0 }],
        otherDirectPepercent: 0,
        otherIndirectPepercent: 0
      }
    }
  })
  data!: RepurchaseConfigDto
  @(Prop({ type: Number, default: 1 })!) level: number
  add() {
    this.data.pepercents.push({ direct: 0, indirect: 0 })
  }
  removeItem(index: number) {
    this.data.pepercents.splice(index, 1)
  }
}
